import { useTranslation } from "react-i18next";

export default function UpdatePayment ({loadingConfirm, handelConfirm, closeConfirmation}) {

    const { i18n } = useTranslation();
    const t = i18n.t.bind(i18n); 
    
    return(
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 gap-4 bg-black bg-opacity-50">
            <div className="bg-white dark:bg-gray-800 w-96 h-52 rounded-lg shadow-xl px-10 pt-9 pb-6 md:pt-9 md:pb-7">
                <div className="relative">
                    <button type="button" onClick={closeConfirmation} className="absolute top-[-32px] left-[-20px] text-white text-[26px] hover:text-danger">
                        x
                    </button>
                </div>
                <h2 className="text-xl md:text-2xl text-center font-semibold mb-6 text-gray-800 dark:text-white">
                    {t("update_payment.confirm")} 
                </h2>
                <p className="mb-10 text-sm md:text-base text-center text-gray-600 dark:text-gray-200">
                    {t("update_payment.activate")} 
                </p>
                <div className="flex items-center justify-between gap-6">
                    <button
                        type="button"
                        onClick={() => handelConfirm("REJECT")}
                        disabled={loadingConfirm}
                        className="flex-1 min-w-[120px] bg-red-600 hover:bg-red-700 text-white text-sm px-4 py-2 rounded"
                        // aria-disabled={loadingConfirm}
                    >
                        {loadingConfirm ? (
                        <span className="inline-flex items-center justify-center">
                            <span className="animate-spin rounded-full h-4 w-4 border-2 border-white border-t-transparent mt-1" />
                        </span>
                        ) : (
                            t("update_payment.notActive")
                        )}
                    </button>
                    <button
                        type="button"
                        onClick={() => handelConfirm("CONFIRM")}
                        disabled={loadingConfirm}
                        className="flex-1 min-w-[120px] bg-green-600 hover:bg-green-700 text-white text-sm px-4 py-2 rounded"
                        // aria-disabled={loadingConfirm}
                        >
                        {loadingConfirm ? (
                            <span className="inline-flex items-center justify-center">
                            <span className="animate-spin rounded-full h-4 w-4 border-2 border-white border-t-transparent mt-1" />
                        </span>
                        ) : (
                            t("update_payment.active")
                        )}
                    </button>
                </div>
            </div>
        </div>
        );
};

